import React from 'react';
import Input from 'es6/components/registration/inputs/input';
import { t } from 'es6/services/localization';

export default function NameInput(props) {
  return (<Input type="text" name="user[name]" placeholder={t('placeholder.name')} {...props} />);
}
